import { ModalV2 } from 'components';
import { titleToLocaleKey } from 'lib';
import { useTranslation } from 'react-i18next';

const RefundView = ({ visible, closeModal, sub, isMobile, refundReason, setRefundReason, onRefund, onBack }) => {
    const { t } = useTranslation();
    if (!sub) return null;

    return (
        <ModalV2 visible={visible} closeModal={closeModal} width={isMobile ? 'calc(100% - 32px)' : '480px'}>
            <div className="p-6 space-y-5">
                <h3 className="text-lg font-bold text-gray-900 font-[CeraPro]">
                    {t('billing.refundTitle')}
                </h3>

                <p className="text-sm text-gray-500 font-[CeraPro] leading-relaxed">
                    {t('billing.refundDescription', {
                        plan: t(`subscription.plans.${titleToLocaleKey(sub.planTitle)}`, { defaultValue: sub.planTitle }),
                        team: sub.teamName
                    })}
                </p>

                <div className="space-y-1.5">
                    <label className="text-xs text-gray-400 font-[CeraPro]">
                        {t('billing.refundReasonLabel')} <span className="text-[#FA3F58]">*</span>
                    </label>
                    <textarea
                        className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm font-[CeraPro] resize-none focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-gray-300 placeholder:text-gray-300 transition-shadow"
                        rows={4}
                        placeholder={t('billing.refundReasonPlaceholder')}
                        value={refundReason}
                        onChange={(e) => setRefundReason(e.target.value)}
                    />
                </div>

                <div className="flex gap-3 pt-1">
                    <button
                        onClick={onBack}
                        className="flex-1 h-11 rounded-full border-2 border-black text-sm font-bold font-[CeraPro] hover:opacity-80 active:scale-[0.98] transition-all"
                    >
                        {t('billing.goBack')}
                    </button>
                    <button
                        onClick={onRefund}
                        disabled={!refundReason.trim()}
                        className="flex-1 h-11 rounded-full bg-[#FA3F58] text-white text-sm font-bold font-[CeraPro] hover:opacity-80 active:scale-[0.98] transition-all disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        {t('billing.submitRequest')}
                    </button>
                </div>
            </div>
        </ModalV2>
    );
};

export default RefundView;
